import sanitizeHtml from 'sanitize-html'

import { guid } from 'core/classes/helpers/GuidHelper'

export const downloadFileByUrl = (uri: string, name: string) => {
  const link = document.createElement('a')
  link.download = sanitizeHtml(name)
  link.href = sanitizeHtml(`${uri}?Guid=${guid()}`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
